/**
 * Mail mixin
 *
 * Добавляет логику для отправки письма на email
 *
 */

export default {
  created() {
    this.initMailActions();
  },
  methods: {
    sendMail(...mail) {
      return this.$robot.mailService.sendMail(...mail);
    },
    onMailSuccess() {
      return this.showThanks?.();
    },
    onMailError() {
      return this.showError?.();
    },
    initMailActions() {
      const robotActions = [
        this.$robot.mailService.onSuccess(this.onMailSuccess),
        this.$robot.mailService.onError(this.onMailError),
      ];
      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
      });
    },
  },
};
